import React from "react";
import { Layout, StakingNFT } from "../components";

const StakingNFTPage = () => {
  return (
    <Layout>
      <StakingNFT />
    </Layout>
  );
};

export default StakingNFTPage;
